import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 答题状态
    answerState:'0',
    answerNumber:'0'
  },
  mutations: {
    // 修改答题状态
    updataAnswerState(state,answerState) {
        state.answerState =answerState
    },
    // 修改答题数量
    updataAnswerNumber(state,answerNumber) {
        state.answerNumber = answerNumber
    }
  },
  actions: {
    // updataAnswerState({commit,state,plalod}){
    //   commit('updataAnswerState',plalod)
    // }
  },
  modules: {
  }
})
